import { Link } from '@eventbrite/eds-link';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';

interface Props {
    onClickCTA: (e: Event) => void;
    ctaLink: string;
    linkLabel: string | GenericLazyString;
}

export const CreatorContent = ({ onClickCTA, ctaLink, linkLabel }: Props) => (
    <h1 className="feed-fullbleed-header__headline">
        <div
            className="eds-text-hl eds-text-color--white eds-l-mar-bot-8 feed-fullbleed-header__text"
            data-spec="hero-image-text"
        >
            {gettext('Create events that bring the world together')}
        </div>
        <div className="feed-fullbleed-header__cta-container">
            <Link
                aria-label={linkLabel}
                onClick={onClickCTA}
                to={ctaLink}
                data-spec="seasonal-cta"
            >
                <div className="feed-fullbleed-header__button eds-text-weight--heavy ">
                    {linkLabel}
                </div>
            </Link>
        </div>
    </h1>
);
